import { render, staticRenderFns } from "./FTokenValue.vue?vue&type=template&id=bd865bb6&"
import script from "./FTokenValue.vue?vue&type=script&lang=js&"
export * from "./FTokenValue.vue?vue&type=script&lang=js&"
import style0 from "./FTokenValue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports